/* eslint-disable @typescript-eslint/no-explicit-any */

// Prevent `scroll` and `wheel` events from triggering change detection.
(window as any).__zone_symbol__UNPATCHED_EVENTS = ['scroll', 'wheel'];
